import ModelUtil from '@leverege/model-util';
import DetailModel from "./DetailModel.js";
function create(type, extend) {
  const base = DetailModel.create(type, extend);
  return {
    ...base,
    value: {
      ...base.value,
      variant: 'detailArrayValue|arrayValue',
      paneVariant: 'detailArray|array',
      layout: 'flex:rowSWrapEnd',
      morePopupVariant: 'detailArrayMore|arrayMore',
      moreToggleVariant: 'detailArrayMore|arrayMore',
      ...extend?.value
    }
  };
}
export default {
  ...DetailModel,
  create,
  ...ModelUtil.createAllValue('value/layout', 'layout'),
  ...ModelUtil.createAllValue('value/paneVariant', 'paneVariant'),
  ...ModelUtil.createAllValue('value/layout', 'layout'),
  ...ModelUtil.createAllValue('value/morePopupVariant', 'morePopupVariant'),
  ...ModelUtil.createAllValue('value/moreToggleVariant', 'moreToggleVariant')
};